var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Delete",
    xmlns: "http://www.w3.org/2000/svg",
    width: 8.667,
    height: 11,
    viewBox: "0 0 8.667 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-delete",
    "data-name": "Icon material-delete",
    d: "M8.119,14.278A1.234,1.234,0,0,0,9.357,15.5H14.31a1.234,1.234,0,0,0,1.238-1.222V6.944H8.119Zm8.048-9.167H14L13.381,4.5h-3.1l-.619.611H7.5V6.333h8.667Z",
    transform: "translate(-7.5 -4.5)",
    fill: "#2b2d2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.3ae80a4feeb78632780c91dd4321f777.svg";
export { ForwardRef as ReactComponent };